export const supportedAnnotationViews = [
  'attachments',
  'duplicates',
  'emails',
  'activities',
  'files',
] as const;

export type SupportedAnnotationView = (typeof supportedAnnotationViews)[number];
